import { Route, Routes, useLocation } from 'react-router-dom';
import { mainRoutes, publicRoutes } from 'utils/routes';

import MainLayout from 'layout/main-layout';
import MiniLayout from 'layout/mini-layout';
import { useEffect } from 'react';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // hoặc "smooth"
    });
  }, [location.key]);

  return null;
}

function App() {
  return (
    <div className='App'>
      <ScrollToTop />
      <Routes>
        {/** Public routes */}
        <Route element={<MiniLayout />}>
          {publicRoutes.length &&
            publicRoutes.map((route, index) => {
              return <Route key={`public-route-${index}`} path={route.path} element={<route.component />} />;
            })}
        </Route>

        {/** Main routes */}
        <Route element={<MainLayout />}>
          {mainRoutes.length &&
            mainRoutes.map((route, index) => {
              return <Route key={`public-route-${index}`} path={route.path} element={<route.component />}></Route>;
            })}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
